import React from 'react'
import { Card, CardContent, CardHeader, Label, Switch } from '@/shared/ui'
import { getOverlaysForMembers, setOverlayMemberVisible } from '../services/chartOverlaySettingsService'
import { useToast } from '@/shared/ui/Toast'

export default function ChartOverlaysSettings() {
  const [loading, setLoading] = React.useState(true)
  const [saving, setSaving] = React.useState<null | 'ema12'|'ema26'|'ema200'|'fibo'>(null)
  const [state, setState] = React.useState({ ema12: false, ema26: false, ema200: false, fibo: false })
  const { add: toast } = useToast()

  React.useEffect(() => {
    let mounted = true
    getOverlaysForMembers()
      .then((cfg) => { if (mounted) setState(cfg) })
      .catch((e) => toast({ title: 'Gráfico — Overlays', description: e?.message || 'Falha ao carregar', variant: 'error' }))
      .finally(() => { if (mounted) setLoading(false) })
    return () => { mounted = false }
  }, [])

  async function toggle(key: 'ema12'|'ema26'|'ema200'|'fibo', value: boolean) {
    if (saving) return
    setSaving(key)
    try {
      await setOverlayMemberVisible(key, value)
      setState((s) => ({ ...s, [key]: value }))
      toast({ title: 'Gráfico — Overlays', description: `${key.toUpperCase()} ${value ? 'visível' : 'oculto'} para membros`, variant: 'success', soft: true })
    } catch (e: any) {
      toast({ title: 'Gráfico — Overlays', description: e?.message || 'Falha ao salvar', variant: 'error' })
    } finally {
      setSaving(null)
    }
  }

  return (
    <Card>
      <CardHeader className="text-base font-semibold">Gráfico — visibilidade para Membros</CardHeader>
      <CardContent>
        <div className="space-y-3 text-sm text-foreground/80">
          <p>Controle quais overlays ficam visíveis para usuários com papel <b>member</b>. Usuários <b>master</b> sempre veem todas as ferramentas.</p>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            <div className="flex items-center justify-between gap-3 rounded border border-border/60 p-2">
              <div>
                <div className="font-medium">EMA 12</div>
                <div className="text-foreground/70">Linha amarela no gráfico principal.</div>
              </div>
              <div className="flex items-center gap-2">
                <Label>Oculto</Label>
                <Switch disabled={loading || !!saving} checked={state.ema12} onChange={(e)=> toggle('ema12', (e.target as HTMLInputElement).checked)} />
                <Label>Visível</Label>
              </div>
            </div>
            <div className="flex items-center justify-between gap-3 rounded border border-border/60 p-2">
              <div>
                <div className="font-medium">EMA 26</div>
                <div className="text-foreground/70">Linha ciano no gráfico principal.</div>
              </div>
              <div className="flex items-center gap-2">
                <Label>Oculto</Label>
                <Switch disabled={loading || !!saving} checked={state.ema26} onChange={(e)=> toggle('ema26', (e.target as HTMLInputElement).checked)} />
                <Label>Visível</Label>
              </div>
            </div>
            <div className="flex items-center justify-between gap-3 rounded border border-border/60 p-2">
              <div>
                <div className="font-medium">EMA 200</div>
                <div className="text-foreground/70">Linha roxa no gráfico principal.</div>
              </div>
              <div className="flex items-center gap-2">
                <Label>Oculto</Label>
                <Switch disabled={loading || !!saving} checked={state.ema200} onChange={(e)=> toggle('ema200', (e.target as HTMLInputElement).checked)} />
                <Label>Visível</Label>
              </div>
            </div>
            <div className="flex items-center justify-between gap-3 rounded border border-border/60 p-2">
              <div>
                <div className="font-medium">Fibonacci</div>
                <div className="text-foreground/70">Linhas 0/0.382/0.5/0.618/1 do último swing confirmado.</div>
              </div>
              <div className="flex items-center gap-2">
                <Label>Oculto</Label>
                <Switch disabled={loading || !!saving} checked={state.fibo} onChange={(e)=> toggle('fibo', (e.target as HTMLInputElement).checked)} />
                <Label>Visível</Label>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

